import { Box } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import Skeleton from '@material-ui/lab/Skeleton';
import { BaseHelmet, TRow, TableView, Thead } from 'components';
import type { FC } from 'react';
import type { IRuntimeState } from '../IRuntimeState';
import { PackageItem } from './PackageItem';
import { PackagePopout } from './PackagePopout';

interface IStatusTabProps {
  isEditable?: boolean;
  loading?: boolean;
  loaded?: boolean;
  clusterState: IRuntimeState;
}

const PackagesTab: FC<IStatusTabProps> = ({ isEditable = true, clusterState, loading, loaded }) => (
  // const inputRef = useRef<any>(null);
  <>
    <BaseHelmet page="Packages" />
    <Box>
      <Box style={{ border: '1px solid #E0E2E5' }} borderRadius="medium" pt="lg" pb="lg" bg="white" boxShadow="subtle">
        <TableView gridTemplateColumns="0.8fr 1fr 0.2fr 0.2fr 0.2fr 0.6fr">
          <Thead
            headerItems={[
              { text: 'account' },
              { text: 'name' },
              { text: 'versions' },
              { text: 'instances' },
              { text: 'Msg count' },
              { text: 'last' }
            ]}
          />

          {mapRecordToArray(clusterState.packages, (pack, packageKey) => (
            <TRow
              key={pack.uuid}
              rowMaxHeight="auto"
              collapsible
              content={
                <PackagePopout
                  packageKey={pack.uuid || packageKey}
                  clusterPackage={pack}
                  services={clusterState.services}
                />
              }
            >
              <PackageItem key={`item_${packageKey}`} packageKey={pack.uuid || packageKey} clusterPackage={pack} />
            </TRow>
          ))}
          {loading && (
            <TRow>
              <>
                <Skeleton width="100%" height="40px" />
                <Skeleton width="100%" height="40px" />
                <Skeleton width="100%" height="40px" />
                <Skeleton width="100%" height="40px" />
                <Skeleton width="100%" height="40px" />
                <Skeleton width="100%" height="40px" />
              </>
            </TRow>
          )}
        </TableView>
      </Box>
    </Box>
  </>
);
export default PackagesTab;
